<template>
  <SmallSquare content='设置优惠、使用条件、使用时间的优惠券，供各个应用模块调用'></SmallSquare>
  <div class="m-b-20 m-t-20 s_flex_bian_c">
    <a-button type="primary" @click="()=> {$router.push('/assets/coupons/shoppingCard/add?type=add')}">
      <PlusOutlined />
      新建卡券
    </a-button>
  </div>
  <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键词" name='keyword'>
      <a-input v-model:value="search.keyword" style="width:200px" placeholder="请输入卡券名称/ID进行搜索" />
    </a-form-item>
    <a-form-item label="券状态" name='status'>
      <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">正常</a-select-option>
        <a-select-option :value="0">失效</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="同步微信卡券" name='synchro'>
      <a-select v-model:value="search.synchro" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">已同步</a-select-option>
        <a-select-option :value="0">未同步</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
    <!-- <a-form-item>
      <a-button type="primary" ghost>导出</a-button>
    </a-form-item> -->
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:condition="{ record }">
      <p>{{record.price}}</p>
      <p>{{record.condition == 1 ?'无门槛':'满'+record.money+'元可用'}}</p>
    </template>
    <template v-slot:time_type="{ record }">
      <p>{{record.time_type == 1 ?'领取日起'+record.day+'天有效' : record.day}}</p>
    </template>
    <template v-slot:action="{ record }">
      <a-dropdown>
        <a class="ant-dropdown-link"> 操作
          <DownOutlined />
        </a>
        <template v-slot:overlay>
          <a-menu>
            <a-menu-item v-if='record.status == 0 || record.status == 2'>
              <router-link :to="'/assets/coupons/shoppingCard/add?type=look&id='+record.id">
                <a href="javascript:;">查看</a>
              </router-link>
            </a-menu-item>
            <a-menu-item v-if='record.status == 1'>
              <a @click="()=> {$router.push('/assets/coupons/shoppingCard/add?type=edit&id='+record.id)}"
                href="javascript:;" >编辑</a>
            </a-menu-item>
            <a-menu-item v-if='record.status == 0'>
              <a @click='invalid(record)' href="javascript:;" >使生效</a>
            </a-menu-item>
            <a-menu-item v-if='record.status == 1'>
              <a @click='invalid(record)' href="javascript:;" >使失效</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
    :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
    @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  <a-modal  :keyboard="false" title="购物券详情" centered v-model:visible="visible" okText='核销'>
    <p class="s_c333 s_lin_h35">领取人OpenID： op2Pfw4QfKRikTE4t8iTGquyhdkQ</p>
    <p class="s_c333 s_lin_h35">购物券名称： 满100减30</p>
    <p class="s_c333 s_lin_h35">券码： SM4039164633036</p>
    <p class="s_c333 s_lin_h35">面值： 30元</p>
    <p class="s_c333 s_lin_h35">使用条件： 满100.00元可用</p>
    <p class="s_c333 s_lin_h35">有效期： 2020/3/24 13:40:39 至2020/4/23 13:40:39</p>
    <p class="s_c333 s_lin_h35">发放时间： 2020/3/24 13:40:39</p>
    <p class="s_c333 s_lin_h35">发放类型： 直接发放</p>
    <p class="s_c333 s_lin_h35">状态： 未使用</p>
  </a-modal>
</template>
<script>
  import { DownOutlined, PlusOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs,createVNode,h } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { getCouponList, setCouponState } from "@/api/assets";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    keyword: "",
    status: '',
    page: 1,
    limit: 10,
    synchro: ''
  };
  export default {
    name: 'couponList',
    components: { DownOutlined, PlusOutlined },
    setup() {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        visible: false,
        listLoading: false,
        time: [],
        total: 1
      });
      let columns = [
        {
          title: "卡券ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "卡券名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "优惠",
          key: "condition",
          align:"center",
          slots: { customRender: "condition" },
        },
        {
          title: "同步微信卡券",
          dataIndex: "is_synchro",
          key: "is_synchro",
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          customRender: ({ record }) => {
            return record.remark ? record.remark : '-'
          }
        },
        {
          title: "已领取",
          dataIndex: "num",
          key: "num",
        },
        {
          title: "有效期",
          key: "time_type",
          slots: { customRender: "time_type" },
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const invalid = async(e) => {
        $Modal.confirm({
          centered: true,
          width: 500,
          title: '确定要使这组购物券'+(e.status ? '失效':'重新生效')+'吗？',
          icon: createVNode(ExclamationCircleOutlined),
          content: h('div', {}, [
            h('p', { className: 'm-b-15' },
            e.status ? '1、失效后，买家无法再领取该购物券，即所有关联到此购物券的活动（含积分换券）的券奖品同步失效，您也不能继续编辑此券内容；':'如若重新生效前，此组购物券已过有效期，则该组券会变成过期券。如若未过期，原已调用的活动，券继续有效。'),
            h('p', e.status ? '2、买家之前已领取到的购物券，在有效期内还能继续使用。':''),
          ]),
          onOk:async()=> { 
            let res = await setCouponState({id:e.id}).then(res => res.data);
            if (iscode(res,true)) {
              setTimeout(()=>{
                initData(search.value);
              },1000)
            }
          },
          onCancel() { },
        });
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getCouponList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            _lodash(res.data.data).forEach(function(value) {
                value.day = value.time_type == 1 ? value.day : _lodash.join(_lodash.split(value.day, ','),'至')
                value.is_synchro = value.is_synchro?'已同步':'未同步'
            });
            data.value = res.data.data;
            state.total = res.data.total;
          }
        } catch (e) {
          state.listLoading = false;
        }
      };


      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        invalid
      };
    },
  };
</script>